import { render } from "./HomeEn.vue?vue&type=template&id=16f1d470&scoped=true"
import script from "./HomeEn.vue?vue&type=script&lang=js"
export * from "./HomeEn.vue?vue&type=script&lang=js"

import "./HomeEn.vue?vue&type=style&index=0&id=16f1d470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f1d470"]])

export default __exports__